"use client";

import React from "react";
import Image from "next/image";
import guideIcon from "@/assets/icons/Common/GuideIcon.svg";
import guideIconRed from "@/assets/icons/Common/GuideIconRed.svg";
import useIconGuide from "./hooks/useIconGuide";
import GuideModal from "./GuideModal";
import "./guide.scss";

const Guide: React.FC = () => {
  const { triggerLabel } = useIconGuide();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <React.Fragment>
      <button
        type="button"
        className="guide-trigger"
        onClick={handleOpen}
      >
        <span className="guide-trigger-text">{triggerLabel}</span>
        <span className="guide-trigger-icon-wrap" aria-hidden>
          <Image
            src={guideIcon}
            alt=""
            width={18}
            height={18}
            className="guide-trigger-icon guide-trigger-icon--default"
          />
          <Image
            src={guideIconRed}
            alt=""
            width={18}
            height={18}
            className="guide-trigger-icon guide-trigger-icon--hover"
          />
        </span>
      </button>
      <GuideModal open={open} onClose={handleClose} />
    </React.Fragment>
  );
};

export default Guide;
